
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import ControlsTree from "@/components/Reusable/ControlsTree/ControlsTree.vue";
import PresetsInDesignTab from "./PresetsInDesignTab.vue";
import { Control } from "@/types/controls";
import { configStore, uiStore } from "@/store/store";

@Component({
  components: {
    ControlsTree,
    PresetsInDesignTab
  }
})
export default class DesignTabContent extends Vue {
  @Prop()
  controls!: Control[];

  @Prop()
  path!: string;

  mode: "presets" | "custom" = "custom";

  changeMode(newMode: "presets" | "custom") {
    this.mode = newMode;
  }

  get presets() {
    if (!uiStore.activeElement) return [];

    return configStore.presetsForElements.filter(
      // @ts-ignore
      p => p.availableForType === uiStore.activeElement.data.type
    );
  }
}
